import { render, staticRenderFns } from "./PatientInput.vue?vue&type=template&id=2502efe8&"
import script from "./PatientInput.vue?vue&type=script&lang=js&"
export * from "./PatientInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports